class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.requestCounter = 0;
    this.resultsWrapper = this.querySelector('search-results');
    this.innerResultsWrapper = this.querySelector('.search-results-wrapper');
    this.wrapperHtml = this.resultsWrapper.innerHTML;
    this.input = this.querySelector('input[type="search"]');
    this.abortController = null;
    this.cached = {};
    this.debounceDelay = 300; 
    this.popularSearches = this.querySelector('[data-popular-searches]');
    this.collectionsList = this.querySelector('[data-collections-list]');
    this.productsList = this.querySelector('[data-products-list]');
     this.boundOnInput = this.debounce(this.onChange.bind(this), this.debounceDelay);
    this.emptyResultsWrapper = this.querySelector('.empty-results-wrapper')
    this.viewAll = this.querySelector('.view_all_search')
    this.setupListeners();
  }

  setupListeners() {
    this.input.addEventListener('input', this.boundOnInput);
    this.input.addEventListener('focus', () => this.toggleDrop(true));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
  }
 
  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  async onChange() {
    this.toggleDrop(true)
    const q = this.input.value.trim();
    if (!q) return this.renderEmpty();
    this.toggleLoading(true); 
    // Cancel previous request
      if (this.abortController) {
        this.abortController.abort();
      }
    
      // Create new controller for this request
      this.abortController = new AbortController();

    if (this.cached[q]) { 
        this.renderResults(this.cached[q] , q);
        this.toggleLoading(false); 
      return;
    } 

    try {
      const data = await fetchInstantWidgets(q, '6D3e2G3e7M', this.abortController.signal);  // ignore stale
      this.cached[q] = data;
      this.renderResults(data, q);
    } catch (e) {
      if (e.name !== 'AbortError') console.error(e);
    } finally {
      
    }
  }

  onKeydown(e) { 
   const key = e.code || e.key || ''; // fallback if code is empty
  
    const allowedKeys = ['ArrowDown', 'ArrowUp', 'Enter'];
    if (allowedKeys.includes(key)) {
      e.preventDefault();
  
      const q = this.input.value.trim();
      if (q) {
        window.location.href = `/pages/search?q=${encodeURIComponent(q)}`;
      }
  }
  }

  toggleDrop(show) {
    this.resultsWrapper.classList.toggle('hidden', !show);
    this.input.setAttribute('aria-expanded', show);
    if(show){
    document.body.classList.add("search-bar-open");
    }
  }

  toggleLoading(isLoading) {
    this.resultsWrapper.classList.toggle('loading', isLoading);
    this.querySelector('.search-loader')?.classList.toggle('hidden' , !isLoading)
  }

  renderEmpty() {
    this.resultsWrapper.innerHTML = this.wrapperHtml;
    this.toggleDrop(true);
  }

  async renderResults(data, query) { 
    const suggestions = data?.suggestions;
    const categories = data?.categories;
    const items = data?.items;
    console.log('data' , query  , data )
     this.popularSearches = this.querySelector('[data-popular-searches]');
    this.collectionsList = this.querySelector('[data-collections-list]');
    this.productsList = this.querySelector('[data-products-list]'); 
    this.emptyResultsWrapper = this.querySelector('.empty-results-wrapper')
     this.innerResultsWrapper = this.querySelector('.search-results-wrapper');
    this.viewAll = this.querySelector('.view_all_search')
    if(items.length){
      this.viewAll?.classList.remove('hidden')
      this.viewAll.setAttribute('href' , `/pages/search?q=${query}`)
      this.innerResultsWrapper?.classList.remove('hidden')
      this.emptyResultsWrapper?.classList.add('hidden')
    this.popularSearches.innerHTML = suggestions.slice(0, 7).map(s => ` <li class="popular_search_term"><a href="/pages/search?q=${s}" class="collection_link_search">${s}</a></li>`).join('');

   let collectionHtml = '';
        if (categories?.length) {
          console.log('categories' , categories)
          // Use categories from Searchanise API
          collectionHtml = categories.slice(0, 7).map(c => `
              <li class="popular_search_term">
                <a href="${c.link}" class="collection_link_search">${c.title}</a>
              </li>
            `).join('');
        } else {
          // Extract up to 7 unique collections from products
         const seen = new Set();
          const unique = [];
          
          // Get restricted collection handles from the global variable
          const restrictedHandles = (window.searchrestictedCollection || '')
            .split(',')
            .map(c => c.toLowerCase().trim().replace(/\s+/g, ''));
          
          for (const p of items) {
            const rawCollections = p?.collections;
            if (!rawCollections) continue;
          
            const collections = rawCollections.split('[:ATTR:]');
          
            for (const title of collections) {
              const handle = title.toLowerCase().replace(/\s+/g, '');
          
              if (!handle || seen.has(handle) || restrictedHandles.includes(handle)) continue;
          
              seen.add(handle);
              unique.push({ handle, title });
          
              if (unique.length >= 7) break;
            }
          
            if (unique.length >= 7) break;
          }
          
          console.log('p categories', unique);
          
          collectionHtml = unique
            .map(c => `
              <li class="popular_search_term">
                <a href="/collections/${c.handle}" class="collection_link_search">
                  ${c.title}
                </a>
              </li>
            `).join('');


        }
      
        this.collectionsList.innerHTML = collectionHtml;

    const handles = items.slice(0, 7)
      .map(p => p.link.split('/products/')[1])
      .filter(Boolean);

    this.productsList.innerHTML = handles.length
      ? await this.getProducts(handles)
      : '';
      this.toggleLoading(false);
    } else{
      const EmptyText = `Sorry, nothing found for ${query}.`
      if(this.emptyResultsWrapper.querySelector('p')) this.emptyResultsWrapper.querySelector('p').textContent = EmptyText;
      this.innerResultsWrapper?.classList.add('hidden')
      this.emptyResultsWrapper?.classList.remove('hidden')
      this.viewAll?.classList.add('hidden')
      this.viewAll.setAttribute('href' , "")
      this.toggleLoading(false);
      
    }

    this.toggleDrop(true);
  }

  async getProducts(handles) {
    const url = `/collections/all?view=search-data&products=${handles.join(',')}`;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);
      return res.text();
    } catch (e) {
      console.error(e);
      return '<p>Unable to load products.</p>';
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);

// Utility: fetch Searchanise widget data
async function fetchInstantWidgets(query, apiKey, signal) {
  const params = new URLSearchParams({
    api_key: apiKey,
    q: query,
    maxResults: '7',
    items: 'true',
    categories: 'true',
    suggestions: 'true',
    sortBy: 'created',
    sortOrder: 'desc',
    output: 'json'
  });
  const res = await fetch(`https://searchserverapi1.com/getwidgets?${params}` , {signal});
  if (!res.ok) throw new Error(res.statusText);
  return res.json();
}